// eslint-disable-next-line import/prefer-default-export
export const getSortDirection = (input) => (input[0] ? 'desc' : 'asc');
export const getSortBy = (input) => (input?.[0]);
export const getSort = (term, direction) => {
  const sortTerm = getSortBy(term);
  if (!sortTerm) {
    return false;
  }
  const sortDirection = getSortDirection(direction);

  return {
    sortTerm,
    sortDirection,
    sorting: {
      [sortTerm]: sortDirection,
    },
  };
};

export const formatOptions = (options = {}) => {
  const sortIndoor = getSort(options.sortBy, options.sortDesc);

  return {
    ...options,
    computed: {
      sort: sortIndoor,
    },
    sorting: sortIndoor?.sorting || false,
  };
};
